import React from 'react'
import { Shield } from 'lucide-react'
import ProtectedTenantRoute from '../components/ProtectedTenantRoute'

const AdminSimple = () => {
  return (
    <ProtectedTenantRoute>
      <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto py-8 px-4">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center mb-4">
            <Shield className="h-8 w-8 text-blue-600 mr-3" />
            <h1 className="text-2xl font-bold">Admin Dashboard</h1>
          </div>

          <div className="space-y-4">
            <div className="bg-green-50 border border-green-200 rounded p-4">
              <h2 className="font-semibold text-green-800">✅ Admin Page Working</h2>
              <p className="text-green-700">This simple admin page is loading successfully.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-blue-50 border border-blue-200 rounded p-4">
                <h3 className="font-semibold text-blue-800">Pending Requests</h3>
                <p className="text-2xl font-bold text-blue-600">--</p>
                <p className="text-sm text-blue-600">Loading...</p>
              </div>

              <div className="bg-green-50 border border-green-200 rounded p-4">
                <h3 className="font-semibold text-green-800">Active Sessions</h3>
                <p className="text-2xl font-bold text-green-600">--</p>
                <p className="text-sm text-green-600">Loading...</p>
              </div>

              <div className="bg-purple-50 border border-purple-200 rounded p-4">
                <h3 className="font-semibold text-purple-800">Total Documents</h3>
                <p className="text-2xl font-bold text-purple-600">47</p>
                <p className="text-sm text-purple-600">Available</p>
              </div>
            </div>

            <div className="flex space-x-4">
              <button
                onClick={() => alert('Feature coming soon!')}
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Manage Requests
              </button>

              <button
                onClick={() => alert('Feature coming soon!')}
                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
              >
                View Analytics
              </button>

              <a
                href="/"
                className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700 inline-block"
              >
                ← Back to Trust Center
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    </ProtectedTenantRoute>
  )
}

export default AdminSimple